<template>
  <main
    class="text-white relative -mt-20 sm:-mt-36 md:-mt-52 xl:-mt-64 z-30 mb-0"
  >
    <Teleport to="body">
      <img
        src="../assets/images/pepite1.png"
        class="sm:hidden w-[15vw] absolute -top-[15px] right-[33vw] rotate-[20deg] z-50"
        style="align-items: center"
      />
    </Teleport>
    <div
      class="mt-28 sm:mt-40 md:mt-0 w-full text-center md:p-20 ombre relative"
    >
      <h1
        class="w-full text-center font-normal text-[12vw] md:text-5xl lg:text-7xl font-veneer mt-6"
      >
        FÉLICITATIONS !
      </h1>
      <img
        src="../assets/images/felicitations-min.png"
        class="md:w-full md:max-w-md lg:max-w-xl -mt-4 m-auto"
        alt=""
      />
    </div>
    <div
      class="w-full text-2xl text-left md:max-w-[400px] lg:max-w-[650px] xl:max-w-[700px] -mt-12 fond-bold mx-auto font-veneer relative"
    >
      <div class="absolute w-full max-w-5xl">
        <img
          src="../assets/images/caddie-min.png"
          class="absolute hidden md:block w-64 lg:w-80 -top-36 -left-64"
        />
      </div>

      <ul
        class="sm:text-xl text-[4.5vw] leading-[4vw] sm:leading-normal mt-16 md:mt-0 md:text-lg xl:text-xl max-w-lg mx-auto px-4"
      >
        <li class="relative text-justify">
          Pour bénéficier de ce gain, vous aurez accès à une cagnotte en ligne
          d’une valeur de 100€. Il vous suffira de remplir le formulaire
          suivant et de déposer les tickets de caisse correspondant aux courses
          effectuées dans le magasin participant avant 31/03/2027. Vous
          recevrez ensuite votre remboursement par virement bancaire .<br /><br />
          Afin de la configurer, veuillez remplir le formulaire suivant :
        </li>
      </ul>

      <div class="w-full text-center mt-6">
        <!--<button class="m-auto">JE PARTICIPE</button>
          <button class="m-auto my-6">
            je n’ai pas encore effectué mes achats
          </button> -->
        <router-link to="/update"
          ><span class="btn block m-auto my-6 !px-16"
            >accéder au formulaire</span
          ></router-link
        >
      </div>
    </div>
  </main>
</template>
<script setup lang="ts">
import router from "@/router";
import { onMounted } from "vue";

onMounted(async () => {
  try {
    const _id = sessionStorage.getItem("_id");
    const uid = sessionStorage.getItem("uid");
    if (!_id || !uid) {
      router.push("/");
    }
  } catch (e) {
    console.error(e);
  }
});
</script>

<style scoped>
.points {
  @apply bg-white absolute h-6 w-6 pt-1 text-red-900 flex justify-center items-center rounded-full text-base xl:text-xl font-bold -left-8;
}
</style>
